import AllApis from "app/Apis/apis";
import { MET_COMPANY_ORDER_COMMISSION_FAILED, MET_COMPANY_ORDER_COMMISSION_REQUEST, MET_COMPANY_ORDER_COMMISSION_SUCCESS } from "app/utils/constants/METCompanyOrder";
import { Axios } from "index";

export const getMETCompanyOrderCommissionHistory = ({ page = 1, sort = "desc", sortBy = "created_at", search_value = "", filters = {},metId,companyId }) => {
    return async (dispatch) => {
        try {
            dispatch({ type: MET_COMPANY_ORDER_COMMISSION_REQUEST });
            const payload = {
                filters: filters,
                searchFields: {
                    string: [
                        "commission.companyDetails.companyName",
                        "commission.companyDetails.firstName",
                        "commission.companyDetails.lastName",
                        "commission.companyDetails.email",
                    ],
                    numbers: [
                        "commission.salesOrderAmount",
                        "commission.commissionPercentage",
                        "commission.commissionAmount",
                    ]
                },
            };
            if (!search_value) {
                search_value = "";
            }

            const urlParams = new URLSearchParams({
                companyId:companyId,
                search: search_value.trim(),
                page: page,
                sort: sort,
                sortBy: sortBy,
            });

            const { data } = await Axios.post(`${AllApis.transactionHistroy.listing(metId)}?${urlParams.toString()}`, { ...payload });

            dispatch({
                type: MET_COMPANY_ORDER_COMMISSION_SUCCESS, payload: {
                    companyOrderHistory: data?.data?.Transaction,
                    totalPage: data?.totalPages,
                    totals:data?.totals
                }
            })
        } catch (error) {
            dispatch({ type: MET_COMPANY_ORDER_COMMISSION_FAILED, payload: error?.response?.data?.message });
        }
    }
}